import { api, ApiError } from './api';
import type { paths } from '../../../../packages/contracts/src/client';
export type AuditPage = paths['/api/v1/audit/events']['get']['responses'][200]['content']['application/json'];
export type AuditSummary = AuditPage['items'][number];
export type AuditDetail = paths['/api/v1/audit/events/{id}']['get']['responses'][200]['content']['application/json'];
export type AuditFilters = {
  purpose: string; from: string; to: string; action: string; actorAccountId: string;
  targetType: string; targetId: string; outcome: string;
};
function query(values: Record<string, string | number>) {
  return new URLSearchParams(Object.entries(values).filter(([, value]) => value !== '').map(([key, value]) => [key, String(value)])).toString();
}
export function listAudit(filters: AuditFilters, page = 1) {
  return api<AuditPage>(`/api/v1/audit/events?${query({ ...filters, page, limit: 20 })}`);
}
export function auditDetail(id: string, purpose: string) {
  return api<AuditDetail>(`/api/v1/audit/events/${encodeURIComponent(id)}?${query({ purpose })}`);
}
export function auditTimeline(targetType: string, targetId: string, purpose: string, page = 1) {
  return api<AuditPage>(`/api/v1/audit/objects/timeline?${query({ targetType, targetId, purpose, page, limit: 20 })}`);
}
export const ACTION_LABELS: Record<string, string> = { LOGIN: '登录', GRANT: '授权', VIEW: '查看', CHANGE: '变更', REVIEW: '审核', EXPORT: '导出', PUBLISH: '发布' };
export const OUTCOME_LABELS: Record<string, string> = { ALLOWED: '允许', DENIED: '拒绝', FAILED: '失败' };
export const TARGET_LABELS: Record<string, string> = {
  Organization: '组织', OrganizationDomain: '组织域', Membership: '会籍', Person: '人员', PersonFact: '履历事实',
  ImportBatch: '导入批次', ImportMapping: '导入字段规则', FirstAdminDesignation: '首位管理员指定', MemberSession: '会员会话',
  DutyTaskResponse: '任务回应', AccountPersonLink: '账号与人员关联', ScopeGrant: '职责授权', Account: '账号', LoginIdentity: '登录身份', StaffSession: '工作人员会话', Activity: '活动',
  MemberProfileCase: '资料变更案', MemberFactProposal: '履历申报', MemberClueSubmission: '会员建言', ClueCollectionTask: '材料征集', ParticipationTopic: '课题',
  TopicSubmission: '课题报送', Term: '届次', Appointment: '任职', PortalContent: '门户稿件', PortalProfile: '门户概况',
  Notification: '通知', NotificationDraft: '通知草稿', Attachment: '附件', DutyTask: '定向任务', CharityRecord: '社会服务记录',
  CharityQuarterTask: '社会服务统计任务', CalendarItem: '会务年历',
  VerificationBatch: '核验批次', ProfileVerificationTask: '会员核验任务', MemberReminder: '会员提醒',
  ImportRow: '导入行', ImportRowAdjudication: '导入行裁决', DataQualityScanRun: '质量扫描运行',
  DataQualityIssue: '数据质量问题', MetricSnapshotRun: '指标快照运行', MetricSnapshot: '指标快照',
  ExportRequest: '导出申请', ExportArtifact: '导出产物', PortalChannel: '门户渠道',
  DomainFeatureActivation: '域功能激活', SystemReminderDispatch: '系统提醒投递', ReminderSweepRun: '提醒扫描运行',
  ActivityArtifact: '活动成果台账', TopicManuscriptVersion: '稿件版本', TopicManuscriptReview: '稿件审核意见',
  PortalChannelRelease: '门户渠道发布回执'
};
export function auditError(error: unknown) {
  if (!(error instanceof ApiError)) return '暂时无法读取，请重试。';
  if (error.reasonCode === 'NO_AUDIT_SCOPE') return '你当前没有生效的审计范围。';
  if (error.status === 403) return '当前没有生效的审计查询权限，请核对我的授权。';
  if (error.status === 404) return '事件不存在，或不在当前授权范围内。';
  if (error.reasonCode === 'INVALID_TIME_RANGE') return '请填写完整时间段，结束须晚于开始，单次不超过 90 天。';
  if (error.reasonCode === 'INVALID_purpose') return '请填写查询目的（最多 500 字）。';
  if (error.reasonCode === 'INVALID_actorAccountId') return '请填写有效的操作人账号编号。';
  return error.status === 400 ? '筛选条件不完整或格式有误，请核对后重试。' : '暂时无法读取，请重试。';
}
